import { render, staticRenderFns } from "./RoomMaster.vue?vue&type=template&id=a62a1224&scoped=true&"
import script from "./RoomMaster.vue?vue&type=script&lang=js&"
export * from "./RoomMaster.vue?vue&type=script&lang=js&"
import style0 from "./RoomMaster.vue?vue&type=style&index=0&id=a62a1224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62a1224",
  null
  
)

export default component.exports